module.exports = __webpack_public_path__ + "img/wallet-addons.c554e2e7.png";